module.exports = __webpack_public_path__ + "img/3.66a90088.jpg";